import type { AppProps } from './App';

import * as React from 'react';

import { elementHasSize } from '@egr/xbox/egr-gui-utils/MiscHelper';
import { captureException } from '@egr/xbox/utils/errors/Error';

interface AppLoaderProps extends AppProps {
    loadIframeResizer: boolean;
}

export const AppLoader: React.FC<AppLoaderProps> = (props: AppLoaderProps) => {
    const [ appComponent, setApp ] = React.useState<React.ReactNode>(null);

    React.useEffect(
        (): void => {
            void (async (): Promise<void> => {
                const { loadIframeResizer, ...appProps } = props;

                try {
                    if (loadIframeResizer) {
                        const script: HTMLScriptElement = document.createElement('script');
                        script.src = 'static/js/iframeResizer.contentWindow.min.js';
                        document.body.appendChild(script);
                    }
                } catch (e) {
                    captureException(e, 'debug');
                }

                const { RealApp } = await import('./renderApp');

                await elementHasSize(document.body);

                setApp(React.createElement(RealApp, appProps));
            })();
        },
        [] // call only once
    );

    return appComponent;
};

AppLoader.displayName = 'AppLoader';